import {get} from 'lodash';
import React, {Component, PropTypes} from 'react';

export default class SubText extends Component {
  static propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
    note: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);
  }

  onClick() {
    if (this.props.onClick) {
      this.props.onClick(this.props.note);
    }
  }

  renderSubtext() {
    const textList = this.props.text.split(/[\[\]]/);
    const spans = [];
    if (textList.length === 3) {
      spans.push(<span>{textList[0]}</span>);
      spans.push(<span className='link' onClick={::this.onClick}>{textList[1]}</span>);
      spans.push(<span>{textList[2]}</span>);
    }
    else {
      spans.push(<span className='link' onClick={::this.onClick}>{this.props.text}</span>);
    }
    return spans;
  }

  render() {
    const {
      className,
    } = this.props;

    return (
      <div className={`subtext-wrapper ${className}`}>
        {this.props.children}
        <div className='subtext'>{this.renderSubtext()}</div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./shared/common/components/SubText.js